import React from 'react';
import { RetryErrorComponent } from '@/components/RetryErrorComponent/RetryErrorComponent';
import { useTranslation } from '@edreamsodigeo/frontend-core';
import { useErrorNavigation } from '@/hooks/useErrorNavigation';

export function SearchExpiredError({ open = true, onClose = () => {} }) {
  const { t } = useTranslation();
  const { reloadSearch, redirectHome } = useErrorNavigation();

  return (
    <RetryErrorComponent
      open={open}
      title={t('pricefreeze.error.search.header')}
      text={t('pricefreeze.error.search.body')}
      retryText={t('pricefreeze.error.search.buttonReTry')}
      reviewText={t('pricefreeze.error.search.buttonReview')}
      onClose={onClose}
      onRetry={reloadSearch}
      onReview={redirectHome}
    />
  );
}
